/**
 * @fileoverview
 * Global Error Handler - Catches all uncaught errors
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorLoggerService } from './error-logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private errorLogger = inject(ErrorLoggerService);

  handleError(error: Error | HttpErrorResponse): void {
    if (error instanceof HttpErrorResponse) {
      // Server error
      this.handleServerError(error);
    } else {
      // Client error
      this.handleClientError(error);
    }

    // Log to error logger service
    this.errorLogger.logError(error);
  }

  private handleServerError(error: HttpErrorResponse): void {
    const message = this.getServerErrorMessage(error);
    console.error('[Server Error]:', message, error);

    // Show user-friendly message
    // You can integrate with a toast/notification service here
    // this.toastService.error(message);
  }

  private handleClientError(error: Error): void {
    console.error('[Client Error]:', error.message, error);

    // Show user-friendly message
    // this.toastService.error('An unexpected error occurred. Please refresh the page.');
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 400:
        return 'Bad request. Please check your input.';
      case 401:
        return 'Your session has expired. Please login again.';
      case 403:
        return 'You do not have permission to perform this action.';
      case 404:
        return 'The requested resource was not found.';
      case 500:
        return 'Server error. Please try again later.';
      case 503:
        return 'Service temporarily unavailable. Please try again later.';
      default:
        return error.error?.message || 'An error occurred. Please try again.';
    }
  }
}

